import { render, staticRenderFns } from "./BookingCreateItems.vue?vue&type=template&id=40d6a32f&scoped=true"
import script from "./BookingCreateItems.vue?vue&type=script&lang=js"
export * from "./BookingCreateItems.vue?vue&type=script&lang=js"
import style0 from "./BookingCreateItems.vue?vue&type=style&index=0&id=40d6a32f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d6a32f",
  null
  
)

export default component.exports